import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
// @ts-nocheck
import { getDPosDom, getSpmCPos, getSpmDPos, getUuid } from "../../../utils";

// 最高位标识是否完成过UEP完整曝光
export var EXPO_TYPE = {
  DISAPPEAR: 0,
  // 0
  START: 1,
  // 1
  HAFT: 2,
  // 1 << 1
  WHOLE: 4,
  // 1 << 2
  EXPOSURED: 8 // 1 << 3
};

function singleAxisPercent(top, height, clientHeight) {
  var containStatus;
  if (top < -height) {
    // 在页面上方的场景;
    containStatus = -1;
  } else if (top < 0) {
    // 页面上方出现一点, 返回对高度百分比;
    containStatus = top / height;
  } else if (top + height < clientHeight) {
    // 完全展现
    containStatus = 0;
  } else if (top < clientHeight) {
    // 页面下面出现一点, 返回对高度百分比;
    containStatus = (top + height - clientHeight) / height;
  } else if (top >= clientHeight) {
    // 完全在页面下面;
    containStatus = 1;
  }
  return containStatus;
}
export function isNoneDom(dom) {
  var expoFixedDom = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if (!dom) {
    return true;
  }
  if (!dom.offsetParent) {
    // fixed dom开关没开启，返回
    if (!expoFixedDom || typeof window.getComputedStyle !== 'function') {
      return true;
    }
    var domStyle = window.getComputedStyle(dom) || {};
    if (!domStyle.position || domStyle.position.toLowerCase() !== 'fixed') {
      return true;
    }
    if (domStyle.display && domStyle.display.toLowerCase() === 'none') {
      return true;
    }
  }
  return false;
}
export function expoSamePosition(newStatus, oldStatus) {
  if (newStatus === 0) {
    return (oldStatus & 7) === 0;
  }
  return newStatus === (oldStatus & newStatus);
}

// 面积 >= 50% || === 100%
export function isEffectiveExpo(status) {
  return (status & (EXPO_TYPE.HAFT | EXPO_TYPE.WHOLE)) !== 0;
}

/**
 * 1、0 -> !0 -> 0
 * 2、50%+ -> 0
 * @returns
 */
export function isFullExpo(status) {
  return (status & EXPO_TYPE.EXPOSURED) === EXPO_TYPE.EXPOSURED;
}

/** *
 * 4位二进制，标识位解释(从右到左) ，最高位供expoOnce使用
 * 第一/二/三位值 0/1、2、4分别是否曝光过比例0%｜0%（离开）、50%、100%
 * 第四位  0/1标识 是否有经过一次uep全曝光，0% -> >=50% -> 0%
 *
 * @param status
 * @param oldStatus
 * @returns {number}
 */
export function setExpoStatus(next, oldStatus) {
  if (next !== EXPO_TYPE.DISAPPEAR) {
    return oldStatus | next;
  }
  if (isEffectiveExpo(oldStatus)) {
    return EXPO_TYPE.EXPOSURED;
  }
  return oldStatus >> 3 << 3;
}
export function getDomXYPercent(el) {
  var _window, _window$document;
  var elRect = el.getBoundingClientRect();
  var docEl = (_window = window) === null || _window === void 0 ? void 0 : (_window$document = _window.document) === null || _window$document === void 0 ? void 0 : _window$document.documentElement;
  var xStatus = singleAxisPercent(elRect.left, elRect.width, docEl.clientWidth);
  var yStatus = singleAxisPercent(elRect.top, elRect.height, docEl.clientHeight);
  var percent = Math.round((1 - Math.abs(xStatus)) * (1 - Math.abs(yStatus)) * 100);
  var areaZero = elRect.height === 0 || elRect.width === 0;
  return [xStatus, yStatus, percent, areaZero];
}

// 放在dom中，避免spm对应多个dom
export function getExpoDomDs(el, spmId, id) {
  if (!el[id]) {
    el[id] = {};
  }
  // 多实例-spmId
  if (!el[id][spmId]) {
    // status 使用二进制标识已经曝光状态: 00标识未曝光，01标识一次有效曝光，11标识uep完整曝光
    el[id][spmId] = {
      uuid: getUuid(),
      status: 0,
      percent: 0,
      // 默认方向为-1, 首屏元素默认以up形式展现;
      direction: [-1, -1]
    };
  }
  var ds = el[id][spmId];
  ds.direction = ds.direction || [-1, -1];
  return ds;
}
function getExpoSpmDPos(el, spma, spmb) {
  var dom = getDPosDom(el);
  var result = {
    dom: dom,
    spmId: ''
  };
  if (!spma || !spmb) {
    return result;
  }
  var spmDPos = getSpmDPos(dom);
  if (dom && spmDPos) {
    var spmIdList = spmDPos.split('.');
    var spmIdLen = spmIdList.length;
    if (spmIdLen === 1) {
      spmIdList.unshift(getSpmCPos(dom));
    }
    if (spmIdList[0] && spmIdList[1]) {
      var spmab = [spma, spmb];
      result.spmId = spmab.concat(spmIdList).join('.');
    }
  }
  return result;
}
function getExpoSpmCPos(el, spmAPos, spmBPos) {
  var result = {
    dom: el,
    spmId: ''
  };
  if (!spmAPos || !spmBPos) {
    return result;
  }
  var cspm = getSpmCPos(el);
  if (!cspm) {
    return result;
  }
  var spmarr = [spmAPos, spmBPos, cspm];
  result.spmId = spmarr.join('.');
  return result;
}
export function getSpmIdAndDom(dom, spma, spmb) {
  var spmDOptions = getExpoSpmDPos(dom, spma, spmb);
  if (spmDOptions.spmId) return spmDOptions;
  var spmCOptions = getExpoSpmCPos(dom, spma, spmb);
  if (spmCOptions.spmId) return spmCOptions;
  return {};
}
export function getExpoInfos(dom) {
  var oldInfo = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var tracert = arguments.length > 2 ? arguments[2] : undefined;
  var _getDomXYPercent = getDomXYPercent(dom),
    _getDomXYPercent2 = _slicedToArray(_getDomXYPercent, 4),
    expoXStatus = _getDomXYPercent2[0],
    expoYStatus = _getDomXYPercent2[1],
    percent = _getDomXYPercent2[2],
    areaZero = _getDomXYPercent2[3];
  var _oldInfo$direction = _slicedToArray(oldInfo.direction, 2),
    expoObjx = _oldInfo$direction[0],
    expoObjy = _oldInfo$direction[1];
  if (areaZero === true || expoObjx === expoXStatus && expoObjy === expoYStatus) {
    // 没有变化
    return;
  }
  var _ref = tracert.expoSection || [],
    _ref2 = _slicedToArray(_ref, 2),
    sectionLeft = _ref2[0],
    sectionRight = _ref2[1];
  var expo = {
    expoDirection: '',
    percent: percent,
    direction: [expoXStatus, expoYStatus]
  };
  // if/else说明
  // if
  //    1、老规则：宽度&&高度进入视图比例>=70%，按照新规则，面积达到49%-70%区间都可能符合老规则，偏差较大保留老规则
  //    2、老规则自动曝光都是mix
  // else
  //    新规则：进入视图的面积不一样就需要上报，新规则用auto
  // 当元素进入页面上70%到下70%之间的时候 且不隐藏
  var effectiveCond = expoYStatus >= sectionLeft && expoYStatus <= sectionRight && expoXStatus >= sectionLeft && expoXStatus <= sectionRight;
  if (effectiveCond) {
    // 判断方向
    if (expoObjy < sectionLeft) {
      expo.expoDirection = 'up';
    } else if (expoObjy > sectionRight) {
      expo.expoDirection = 'down';
    } else if (expoObjx < sectionLeft) {
      expo.expoDirection = 'left';
    } else if (expoObjx > sectionRight) {
      expo.expoDirection = 'right';
    } else if (oldInfo.percent !== percent) {
      expo.expoDirection = '';
    }
  } else if (oldInfo.percent === percent) {
    return;
  }
  return expo;
}